import React, { Component } from "react"
import Slider from "react-slick"
import "./index.css"

const LeftArrow = ({ className, style, onClick }) => {
  return (
    <button
      className={`variety-show-left-arrow`}
      onClick={onClick}
      style={{
        ...style,
      }}
    >
      <i
        style={{ fontSize: 165, color: "rgb(167, 167, 167, 0.8)" }}
        className="btn fa fa-caret-left"
      />
    </button>
  )
}

const RightArrow = ({ className, style, onClick }) => {
  return (
    <button
      className={`variety-show-right-arrow`}
      onClick={onClick}
      style={{
        ...style,
      }}
    >
      <i
        style={{ fontSize: 165, color: "rgb(167, 167, 167, 0.8)" }}
        className="btn fa fa-caret-right"
      />
    </button>
  )
}

class VarietyShowSlider extends Component {
  render() {
    var settings = {
      dots: false,

      infinite: true,
      speed: 500,
      fade: true,
      autoplay: true,
      autoplaySpeed: 4000,
      slidesToShow: 1,
      slidesToScroll: 1,
      nextArrow: <RightArrow />,
      prevArrow: <LeftArrow />,
    }

    return (
      <Slider {...settings}>
        <div>
          <img
            className="img-fluid m-0 w-100"
            src={require("../../../../images/Home/Woodstock-Showmotiv.png")}
          />
        </div>
        <div>
          <img
            className="img-fluid m-0 w-100"
            src={require("../../../../images/Home/Woodstock-Showmotiv.png")}
          />
        </div>
      </Slider>
    )
  }
}

export default VarietyShowSlider
